import Vue from 'vue';
import { mapState } from 'vuex';

import $ from 'jquery';
import 'jquery-validation';
import 'jquery-ui/ui/widgets/tooltip';

// import KsRadio from 'ksc-vue-ui2/src/components/kecRadio/Radio.vue';
// import KsDialog from 'ksc-vue-ui2/src/components/dialog/index.vue';
// import KsPagesNewStyle from 'ksc-vue-ui2/src/components/KsPagesNewStyle/index.vue';
// import KsTableAdv from 'ksc-vue-ui2/src/components/KsTableKvm/index.vue';
// import KsTableAdvColumn from 'ksc-vue-ui2/src/components/KsTableAdvColumn/index.vue';
// import KsTimerSlider from 'ksc-vue-ui2/src/components/KsTimerSlider/index.vue';
// import KsTimerSlidertext from 'ksc-vue-ui2/src/components/KsTimerSlidertext/index.vue';
// import KsSwitch from 'ksc-vue-ui2/src/components/KsOnOffKvm/index.vue';
// import EventHub from 'ksc-vue-ui2/src/services/EventHub';
// import KsSlider from 'ksc-vue-ui2/src/components/KsSliderBar/index.vue';

import KsBtn, { ButtonGroup } from 'kpc/components/button';
import Tooltip from 'kpc/components/tooltip';
import Slider from 'kpc/components/slider';
import Spinner from 'kpc/components/spinner';
import {Select, Option, OptionGroup} from 'kpc/components/select';
import Checkbox from 'kpc/components/checkbox';
import Message from 'kpc/components/message';
import pInput from 'kpc/components/input';
import Table, {TableColumn} from 'kpc/components/table';
import Pagination from 'kpc/components/pagination';
import Radio from 'kpc/components/radio';
// import DateUtil from '../../services/common/DateUtil';

import * as step1Const from '../../store/create/step1/constants';
import * as step3Const from '../../store/create/step3/constants';
import * as pcommon from '../../store/common/constants';
import * as commonConst from '../../store/common/constants';
let opTimeNow = new Date() * 1;
let debounceTimer = 10;

export default {
    name: 'QuickCreate',
    components: {
        KsBtn,
        ButtonGroup,
        // KsRadio,
        // KsDialog,
        // KsPagesNewStyle,
        // KsTableAdv,
        // KsTableAdvColumn,
        // KsTimerSlider,
        Tooltip,
        // KsSwitch,
        pInput,
        Select,
        Option,
        OptionGroup,
        // KsTimerSlidertext,
        Slider,
        Checkbox,
        Spinner,
        Table,
        TableColumn,
        Pagination,
        // KsSlider,
        Radio
    },
    data() {
        return {
            networkConfig: 'auto',
            buyEip: true,
            isShow:false,
            SKIP: '',
            regionKeyCheck:'',
            bossRegionList:[],
            newBossRegionList:[],
            azCode:'',
            azList:[],
            packCode:'',
            packList:[],
            newPackList:[],
            osImageList:[],
            imageId:'',
            vpcId:'',
            vpcList:[],
            subnetId:'',
            subnetList:[],
            ipListLength:0,
            bandwidth: 1,
            minBandwidth: 1,
            maxBandwidth: 200,
            step: 1,
            unit: 'Mbps',
            formattedPriceData: {},
            hasSpecialDiscount: false,
            hasCommonDiscount: false,
            hasPackageDiscount: false, //是否套餐折扣
            commonDiscountList: [],
            // limitNum: 50,
            // kecCount: 1,
            // duration: '1',
            loginMode: true,
            cpu:0,
            mem:0,
            kecName:'',
            isWindows: false,
            isWin2008: false,
            isUbuntu: false,
            imageObj:{},
            lineObj:{},
            lineType:'',
            provider:'',
            securityGroupId:'',
            isCreateVpc: false,
            isCreateSubnet:false,
            pageLanguage: 'zh',
            soldoutArr: [],
            allSoldoutPackageSet: [],
            systemDisk:{
                type: 'ssd',
                value: 20
            },
            noLoginQuickCreate:false, //false代表用户登录，true代表用户未登录
            checkedRows: [],
            kecType: 656,
            systemDiskMap: {
                "Local_SSD": "ssd_systemDisks",
                "SSD2.0": "ebs_ssd2.0_systemDisks",
                "SSD3.0": "ebs_ssd3.0_systemDisks",
                "SATA2.0": "ebs_sata2.0_systemDisks",
                "ssd_disk": "ssd_systemDisks",
                "ssd_ebs": "ebs_ssd2.0_systemDisks",
                "EHDD": "ebs_ehdd_systemDisks",
                "ESSD": "ebs_essd_systemDisks",
            },
            allDiskNameMap: {
                'Local_SSD': this.$trans(`本地SSD`),
                'SSD': this.$trans(`云硬盘2.0（SSD）`),
                'SATA': this.$trans(`云硬盘2.0（SATA）`),
                'SSD3.0': this.$trans(`云硬盘3.0（SSD）`),
                'EHDD': this.$trans(`高效云盘`), // 高效云盘
                'ESSD': this.$trans(`ESSD云硬盘`), // ESSD云盘
            },
            orderBill: 1,
            systemDiskTypes: [],
            sysDiskObj: {},
            systemDiskType: '',
            isShowSlider: false,
            systemDiskObj: {},
            systemDiskSize: 0,
            systemDiskMin: 0,
            systemDiskMax: 500,
            systemDiskStep: 1,
            systemDiskUnit: 'G'
        }
    },
    props: {
        regionKey: {
            type: String,
            default: ''
        },
        locals: {
            type: Object,
            default: () => {
                return {}
            },
            required: false
        },
        kecCount:{
            type: Number,
            default:1,
            required: false
        },
        duration:{
            type:String,
            default:'1',
            required:false
        },
    },
    created() {
        this.noLoginQuickCreate = this.$parent.$vnode.tag.includes('noLoginQuickCreate')
        this.SKIP = _.get(window, 'KSC_SECNET_CONSOLE.BASE_HOST', 'console.ksyun.com');
        
        // 获取页面当前语言
        this.pageLanguage = window.KSC_SECNET_CONSOLE.LANG || 'zh';

        // EventHub.$on('on-createVpcResult-close', () => {
        //     this.$set(this, 'isCreateVpc', false);
        // });
        // EventHub.$on('on-createVpcResult-ok', () => {
        //     this.$set(this, 'isCreateVpc', false);
        //     // this._fetchVpcData();
        // });

        // EventHub.$on('on-createSubnetResult-close', () => {
        //     this.$set(this, 'isCreateSubnet', false);
        // });
        // EventHub.$on('on-createSubnetResult-ok', () => {
        //     this.$set(this, 'isCreateSubnet', false);
        //     // this._fetchVpcData();
        // });
        this.changeBuyData()
    },
    mounted() {

    },
    methods: {
        tryDoChunk(val,newVal){
            let num = this.pageLanguage == 'zh' ? 9 : 6; //UI设计：中文版和英文版展示region数量有差异
            this[val].length && (this[newVal] = _.chunk(this[val], num));
        },
        changeBuyData(params={}){
            let param = {
                duration:this.duration,
                isKs3Region:this.isKs3Region,
                discountList:this.discountList
            }
            this.$emit('resetBuyData',param)
        },
        setInitData(params) {

            _.map(_.keys(params), (key) => {
                if (key != 'isShow') {
                    this[key] = params[key];
                }
            });
            return this._fetch(params.isShow);
        },
        _fetch: _.debounce(function (isShow) {
            console.log('fetch timestamp start', new Date() - opTimeNow);
            let me = this,
                promise = $.Deferred();
            promise = $.when(this._fetchKecData(),
                this._fetchLineSet(),
                this._fetchEipData(),
                this._hasSpecialDiscount(),
                this._fetchOSImage(),
            );


            return promise.then(function (res) {
                console.log('fetch timestamp done', new Date() - opTimeNow);
                return res;
            }, (e) => {

            }).then(() => {
                this.outPut();
                this.isShow = isShow;
            });
        }, debounceTimer),
        /*********云主机部分 */
        _fetchKecData() {
            const QuickCreateUrl = this.noLoginQuickCreate ? step1Const.noLoginQueryKecData : step1Const.QueryKecData
            return this.$store.dispatch(QuickCreateUrl, {
                    params: {
                        Region: this.regionKey
                    }
                }
            ).then((res) => {
                let dataCenter = {},
                    me = this;
                if (_.get(this.kecData, 'productGroupId') == 100) {
                    dataCenter = this.kecData;
                }
                let products = _.get(dataCenter, 'productTypeList', []);
                // 各种购买权限判断
                if (_.isEmpty(dataCenter) || _.isEmpty(products)) {
                    return Message.error(this.$trans(`您没有配置任何机房的购买权限，请联系客服400-028-9900`));
                    //您没有配置任何机房的购买权限，请联系客服
                }
                // if(_.findIndex(this.soldoutList,item=>item.ProductType == 303) == -1){
                //     return Message.error('基础性E1已售罄');
                // }
                var e1 = _.filter(products,item=> item.productTypeId==this.kecType)
                if(e1.length == 0){
                    return Message.error(this.$trans(`您没有星河云服务器购买权限，请联系客服`)); 
                }
                if(_.findIndex(_.get(e1,'[0].billTypeList'),item=>item.billTypeId == 1) == -1){
                    return Message.error(Vue.$trans(`星河云服务器未配置预付费包年包月权限，请联系客服!`)); 
                }
                // 处理数据格式
                e1 = _.get(e1,'[0]',[]);

                // this.baseKvmList = products;

                let allData = this._handleData(e1);
                this.soldoutArr = (this.soldoutList && this.soldoutList.length) ? this._handleSoldoutData(this.soldoutList) : [];
                
                // this.soldoutArr = HandleData._handleSoldoutData(this.soldoutList)
                // console.log(this.soldoutArr,"soldoutarrrrrrr")
                console.log('_handleData timestamp end', new Date() - opTimeNow);
                this.queryKvmList = _.cloneDeep(allData);
                this.fetchRegion();

            }).catch(e=>{
                Message.error(e)
            })
        },
        isSoldOutPackage(packageCode) {
            return _.includes(this.allSoldoutPackageSet, packageCode);
        },
        _handleSoldoutData(data) {
            let soldoutData = [];
            _.forEach(data, item => {
                let obj = {};
                let packageCode = [];
                _.forEach(soldoutData, sitem => {
                    if (sitem.az == item.AvailabilityZone) {
                        obj = sitem
                    }
                })
                if (item.PackageSellOuts && item.PackageSellOuts.length) {
                    _.forEach(item.PackageSellOuts, (pItem) => {
                        if (pItem.SellOutStatus) {
                            packageCode.push(pItem.PackageCode)
                        }
                    })
                }

                if (obj.az) {
                    if (item.AllSellOutStatus) {
                        if (!obj.kec) {
                            obj.kec = new Set();
                        }
                        obj.kec.add(item.ProductType);
                    }
                    obj.kecPackage.add(packageCode);
                } else {
                    obj.az = item.AvailabilityZone;
                    if (item.AllSellOutStatus) {
                        if (!obj.kec) {
                            obj.kec = new Set();
                        }
                        obj.kec.add(item.ProductType);
                    }
                    obj.kecPackage = new Set();
                    obj.kecPackage.add(packageCode);
                    soldoutData.push(obj);
                }
            })
            return soldoutData;
        },
        // 处理价格体系数据格式
        _handleData(e1){
            let me = this;
            let result = [];
            // 综合所有item信息
            _.forEach(e1.packageList,pack_item=>{
                let regions = pack_item.refRegionList;
                _.forEach(regions, region_item => {
                    let azs = region_item.azList;
                    _.forEach(azs,az_item=>{

                        let isSoldout = _.find(me.soldoutList, soldoutItem => {
                            return soldoutItem.ProductType == e1.productTypeId && soldoutItem.AvailabilityZone === az_item.azCode && soldoutItem.AllSellOutStatus;
                        });
                        if (isSoldout) {
                            return;
                        }

                        let basicData = {};
                        basicData.cpu = _.get(_.find(pack_item.packageInfo, ["propCode", "cpu"]) || {}, 'propValue[0].min');
                        basicData.mem = _.get(_.find(pack_item.packageInfo, ["propCode", "mem"]) || {}, 'propValue[0].min');
                        if((basicData.cpu == 1 && basicData.mem == 1)|| (basicData.cpu == 1 && basicData.mem == 2)||(basicData.cpu == 2 && basicData.mem == 4) ||(basicData.cpu == 4 && basicData.mem == 8)){
                            basicData.region = region_item;
                            basicData.regionCode = region_item.regionCode;
                            basicData.regionName = region_item.regionName;
                            basicData.az = az_item;
                            basicData.azCode = az_item.azCode;
                            basicData.azName = az_item.azName;

                            basicData.propertyList = e1.propertyList;
                            basicData.name = e1.productTypeName
                            basicData.productTypeId = e1.productTypeId;
                            basicData.packageInfo = pack_item.packageInfo;
                            basicData.packageCode = pack_item.packageCode;

                            // basicData.ssd = _.get(_.find(pack_item.packageInfo, ["propCode", "ssd"]) || {}, 'propValue[0].min');
                            if(basicData.cpu == 1 && basicData.mem == 1){
                                basicData.desc = Vue.$trans(`适用于大中小型应用，数据库等不同场景。`) //"适用于大中小型应用，数据库等不同场景。"
                            }
                            if(basicData.cpu == 1 && basicData.mem == 2){
                                basicData.desc = Vue.$trans(`适用于低延时、IO密集型应用以及对网络实时性要求较高的应用。`) //"适用于低延时、IO密集型应用以及对网络实时性要求较高的应用。"
                            }
                            if(basicData.cpu == 2 && basicData.mem == 4){
                                basicData.desc = Vue.$trans(`适用于低延时、IO密集型、高磁盘IO负载等应用场景。`) //"适用于低延时、IO密集型、高磁盘IO负载等应用场景。"
                            }
                            if(basicData.cpu == 4 && basicData.mem == 8){
                                basicData.desc = Vue.$trans(`适用于专业数据处理等场景。`) //"适用于专业数据处理等场景。"
                            }
                            result.push(basicData);
                        }

                    })
                })
            })
            console.log(result,"after......综合所有item信息")
            // 按照region分组
            let arr = [];
            _.forEach(result,item=>{
                let regionObj ={}
                _.forEach(arr,aitem=>{
                    if(item.regionCode == aitem.regionCode){
                        regionObj = aitem
                    }
                })
                if (regionObj.regionCode) {
                    regionObj.data.push(item);
                } else {
                    regionObj.regionCode = item.regionCode;
                    regionObj.regionName = item.regionName;
                    var datas = [];
                    datas.push(item);
                    regionObj.data = datas;
                    arr.push(regionObj)
                }
            })
            console.log(arr,"after......按照region分组")
            // 按照az分组
            _.forEach(arr,ritem=>{
                let azs=[]
                _.forEach(ritem.data,aitem=>{
                    let azObj={};
                    _.each(azs, az => {
                        if (aitem.azCode == az.azCode) {
                            azObj = az;
                        }
                    })
                    if (azObj.azCode) {
                        azObj.data.push(aitem)
                    } else {
                        azObj.azCode = aitem.azCode;
                        azObj.azName = aitem.azName;
                        let datas = [];
                        datas.push(aitem);
                        azObj.data = datas;
                        azs.push(azObj);
                    }
                })
                azs.sort((a, b) => {
                    let azCode_a = _.get(a, 'azCode', '');
                    let azCode_b = _.get(b, 'azCode', '');
                    return azCode_a.charCodeAt(azCode_a.length - 1) - azCode_b.charCodeAt(azCode_b.length - 1);
                });
                ritem.azs = azs;

            })
            console.log(arr,"after......按照az分组")
            // 按照packageCode分组
            _.forEach(arr,ritem=>{

                _.forEach(ritem.azs,aitem=>{
                    let pack = []
                    _.forEach(aitem.data,item=>{
                        let packObj={}
                        _.each(pack, pitem => {
                            if (pitem.packageCode == item.packageCode) {
                                packObj = pitem;
                            }
                        })
                        if (packObj.packageCode) {
                            packObj.data.push(item)
                        } else {
                            packObj.packageCode = item.packageCode;
                            packObj.packageInfo = item.packageInfo;
                            packObj.cpu = item.cpu;
                            packObj.mem = item.mem;
                            packObj.name = item.name;
                            packObj.productTypeId = item.productTypeId;
                            packObj.desc = item.desc;
                            let datas = [];
                            datas.push(item);
                            packObj.data = datas;
                            pack.push(packObj);
                        }
                    })
                    aitem.pack = pack;
                })

            })
            console.log(arr,"after......按照pack分组")
            return arr;
        },
        fetchRegion(){
            // console.log(this.regionKey,"传入的regionkey",this.queryKvmList)
            let bossRegionList = _.cloneDeep(this.queryKvmList)
            if(!this.regionKey) return;
            let isExist = _.find(this.queryKvmList,item =>{return this.regionKey == item.regionCode})
            // console.log(isExist, 123)
            if(isExist) {
                this.regionKeyCheck = this.regionKey
            }else{
                this.regionKeyCheck = (bossRegionList && bossRegionList.length) ? bossRegionList[0].regionCode : ''
            }
            _.forEach(bossRegionList, (item) => {
                item.areaCode = item.regionCode.split('-')[0];
            });
            this.bossRegionList = bossRegionList;
            this.tryDoChunk('bossRegionList','newBossRegionList')
            // console.log(this.regionKeyCheck)
            this.fetchAz()
        },
        fetchAreaList(val) {
            if (val.length) {
                let areaList = [];
                let tempData = '';
                _.forEach(val, (item) => {
                    if (tempData != item.areaCode) {
                        areaList.push(_.filter(val, (subitem) => {
                            return subitem.areaCode == item.areaCode;
                        }) || []);
                    }
                    tempData = item.areaCode;
                });
                return areaList;
            }
        },
        filterAreaGroup(val, idx) {
            if (val.length) {
                let lineLeft = "line_left";
                let lineRight = "";
                let i = idx - 1 ? idx : 0;
                let j = idx + 1;
                if (idx > i) {
                    let iArr = _.map(this.newBossRegionList[i], 'areaCode');
                    lineLeft = _.includes(iArr, val) ? "" : "line_left";
                }
                if (val == _.last(this.newBossRegionList[idx]).areaCode) {
                    let jArr = _.map(this.newBossRegionList[j], 'areaCode');
                    lineRight = _.includes(jArr, val) ? "" : "line_right";
                }

                return lineLeft + " " + lineRight;
            }
        },
        fetchAz(){
            let me = this;
            let regionObj = _.find(me.bossRegionList, item => {
                return me.regionKeyCheck == item.regionCode;
            });
            let az = _.get(regionObj, 'azs', []);
            if (_.isEmpty(az)) {
                this.azList = [];
                this.hasAz = false;
            } else {
                this.hasAz = true;
                this.azList = az;
                let isExit = _.find(this.azList, item => {
                    return item.azCode == me.azCode;
                });
                if (!isExit) {
                    me.azCode = _.get(this.azList,'[0].azCode')
                }
            }

            this.soldoutArr = (this.soldoutList && this.soldoutList.length) ? this._handleSoldoutData(this.soldoutList) : [];
            let soldoutkecPackageSet = _.get(_.find(this.soldoutArr, item => item.az == this.azCode) || {}, "kecPackage", []);
            let allPackageSet = [];
            let newArray = Array.from(soldoutkecPackageSet);
            _.forEach(newArray, (item) => {
                allPackageSet = allPackageSet.concat(item);
            });
            this.allSoldoutPackageSet = allPackageSet;

            this.fetchPack()
        },
        isSoldOutAZ(item){
            // az售罄，占坑
            return false;
        },
        isSupportAz(item){
            // az售罄，占坑
            return false;
        },
        fetchPack(){
            let me = this;
            let azObj = _.find(me.azList, item => {
                return me.azCode == item.azCode;
            });
            let pack = _.get(azObj, 'pack', []);
            if (_.isEmpty(pack)) {
                this.packList = [];

            } else {
                this.packList = _.sortBy(pack,['cpu','mem']);

                let isExit = _.find(this.packList, item => {
                    return item.packageCode == me.packageCode;
                });
                // if (!isExit) {
                //     me.packCode = _.get(this.packList,'[0].packageCode')
                // }
                if (!isExit) {
                    let noSoldoutPackage = _.filter(this.packList, (item) => {
                        return !_.includes(this.allSoldoutPackageSet, item.packageCode)
                    });
                    if (noSoldoutPackage && noSoldoutPackage.length) {
                        me.packCode = _.get(noSoldoutPackage, '[0].packageCode', '');
                    } else {
                        me.packCode = '';
                    }
                }
            }
            this.tryDoChunk('packList','newPackList')
        },
        /*********镜像部分 */
        _fetchOSImage: _.debounce(function () {
            const kecImageListUrl = this.noLoginQuickCreate ? step1Const.noLoginkecImageList : step1Const.kecImageList
            return this.$store.dispatch(kecImageListUrl, {
                params: {
                    Region: this.regionKeyCheck || this.regionKey
                }
            }).then(() => {
                return this.formateOsImage();
            }).catch(e=>{
                Message.error(e)
            });
        }, debounceTimer),
        formateOsImage() {
            let me = this;


            var regionKey = me.regionKeyCheck;
            var os = _.cloneDeep(me.osImages);
            var centosList=[],windoesList = [],ubuntuList=[];

            let imageConfigOfE1 = _.find(me.pTypeConfig, ['p_type', 303]);
            // console.log(imageConfigOfE1, 890);
            var regexp = _.map(imageConfigOfE1.imageList, function (item) {
                return '(^' + item + '$)'
            }).join('|');
            regexp = new RegExp(regexp, 'i');

            if (this.pageLanguage == 'en') {
                _.forEach(os, (item) => {
                    _.forEach(item, (subItem) => {
                        if (subItem.imageEnName) {
                            subItem.imageName = subItem.imageEnName;
                        }
                    });
                });
            }

            _.mapKeys(os, (value, key) => {
                value = _.filter(value, (v) => {
                    return regexp.test(v.imageVersion);
                });
                switch(key){
                    case("CENTOS"):
                        centosList = value;
                        break;
                    case("WINDOWS"):
                        windoesList = value;
                        break;
                    case("UBUNTU"):
                        ubuntuList = value;
                        break;
                }
            })
            var osImageList = [
                {
                    label:'CENTOS',
                    list:centosList
                },
                {
                    label:'WINDOWS',
                    list:windoesList
                },
                {
                    label:'UBUNTU',
                    list:ubuntuList
                }
            ]
            _.forEach(osImageList,list=>{
                list.list = _.sortBy(list.list, image => {
                    var version = image.imageVersion && image.imageVersion.match(/(\d+\.?)+/);
                    // 字符排序
                    return version;
                }).reverse();
            });
            this.osImageList = osImageList;

            let isExit = _.find(this.osImageList, item => {
                _.find(item.list, image_item=>{
                    return image_item.imageId == me.imageId
                })
            });
            if (!isExit) {
                me.imageId = _.get(this.osImageList,'[0].list[0].imageId')
                me.imageObj = _.get(this.osImageList,'[0].list[0]')
            }

        },
        _onImageChange(){
            _.forEach(this.osImageList,ositem=>{
                _.forEach(ositem.list,item=>{
                    if(item.imageId == this.imageId){
                        this.imageObj = item
                    }
                })
            })
            var imageObj = this.imageObj;
            // 没有镜像
            if (!imageObj || _.isEmpty(imageObj)) {
                return;
            }
            let me = this,
                cloudOsType,
                isWindows = false,
                isWin2008 = false,
                isUbuntu = false,
                sysDisk = 0;
            cloudOsType = imageObj.imageVersion;
            isWindows = /win.*/i.test(cloudOsType.toLowerCase());
            isWin2008 = /win.*2008/i.test(imageObj && imageObj.imageVersion);
            isUbuntu = /ubuntu/i.test(imageObj && imageObj.imageVersion);

            // 是否是windows系统的标识
            this.isWindows = isWindows;
            this.isWin2008 = isWin2008;
            this.isUbuntu = isUbuntu;

            var sysDiskType = commonConst.isCommonModelType(this.kecType) ? 'ebs_ssd' : 'ssd';

            this.systemDisk = {
                type: sysDiskType,
                value: isWindows ? (isWin2008 ? 40 : 50) : 20 //isWindows ? (isWin2008 ? 40 : 50) : 20
            };
            let sysDistValue = sysDisk > this.systemDisk.value ? sysDisk : this.systemDisk.value;
            let rem = sysDistValue % this.systemDiskStep;
            rem ? this.systemDiskMin = sysDistValue - rem + 10 : this.systemDiskMin = sysDistValue;
            this.systemDiskObj = {
                minValue: this.systemDiskMin,
                maxValue: this.systemDiskMax
            }

        },
        /*********vpc子网部分 */
        //获取VPC相关
        _fetchVpcData: function () {
            var self = this;
            var params = {
                azCode: self.azCode,
                Region: self.regionKeyCheck,
                subnetType: 'Normal',
            }
            const AllVpcInfoUrl = this.noLoginQuickCreate ? step3Const.noLoginAllVpcInfo : step3Const.AllVpcInfo
            return this.$store.dispatch(AllVpcInfoUrl, params).then(() => {
                var allVpcSet = self.allVpcSet;
                var vpcList = _.map(allVpcSet.VpcSet, (item) => {
                    if (item.ProvidedIpv6CidrBlock) {
                        item.title = item.VpcName + " (" + item.CidrBlock + "，" + _.get(item, 'Ipv6CidrBlockAssociationSet[0].Ipv6CidrBlock', '') + " )";
                    } else {
                        item.title = item.VpcName + " (" + item.CidrBlock + ")";
                    }
                    return item;
                });
                self.vpcList = vpcList;
                if (!_.find(vpcList, (item) => { return item.VpcId == this.vpcId })) {
                    this.vpcId = _.get(vpcList,'[0].VpcId','');
                }
                this._filterSubNet();

            }).catch(e=>{
                Message.error(e)
            });

        },
        _filterSubNet: function () {

            var res = _.filter(this.allVpcSet.SubnetSet, (item) => {
                return item.VpcId == this.vpcId;
            });
            res = _.map(res, (item) => {
                item.title = item.SubnetName + " (" + item.CidrBlock + ")";

                return item;
            });
            res = _.filter(res, (item) => {
                return item.title
            });
            this.subnetList = res;
            if (!_.find(res, (item) => { return item.SubnetId == this.subnetId})) {
                this.subnetId = _.get(res,'[0].SubnetId','');
            }
            return this._fetchAdrList();
        },
        //已用IP接口
        _fetchAdrList: _.debounce(function () {
            var self = this;
            if (!self.subnetId) return;
            const AdrListUrl = this.noLoginQuickCreate ? step3Const.noLoginAdrList : step3Const.AdrList
            return this.$store.dispatch(AdrListUrl, {
                subnetId: self.subnetId,
                Region: self.regionKeyCheck,
            }).then((data) => {
                // 读取AdrList判断是否可用ip大于所创建主机数量
                if(self.kecCount > self.adrListSet.AvailableIpAddress.length){
                    Message.error(this.$trans(`可用ip数量小于所选主机数量`)); //可用ip数量小于所选主机数量
                }

            }).catch((e) => {
                Message.error(e.msg || e);
            });
        }, 100),
        //关联安全组
        // _filterSecurityGroup: function () {
        //     var res = _.filter(this.allVpcSet.SecurityGroupSet, (item) => {
        //         return item.VpcId == this.vpcId;
        //     });
        //     this.securityGroupId = _.get(res,'[0].SecurityGroupId','');
        //     this.outPut();
        //
        // },
        /*********带宽部分 */
        // 链路类型-----默认bgp
        _fetchLineSet() {
            const GetlinesUrl = this.noLoginQuickCreate ? pcommon.noLoginGetlines : pcommon.Getlines
            return  this.$store.dispatch(GetlinesUrl, {
                params: {
                    Region: this.regionKeyCheck || this.regionKey
                }
            }).then(() => {
                return this.initLineSetData();
            }).catch((e) => {
                Message.error(e.msg || e);
            });
        },
        _fetchEipData() {
            const QueryProductGroupsUrl = this.noLoginQuickCreate ? pcommon.noLoginQueryProductGroups : pcommon.QueryProductGroups
            return this.$store.dispatch(QueryProductGroupsUrl, {
                params: {
                    productGroupIdList: '113,102',
                    Region: this.regionKeyCheck || this.regionKey
                }
            }).then((res) => {
                // 默认不加入共享带宽
                this._initPackage(102, 9, 'net');;
            }, (e) => {
                Message.error(e.msg || e);
            });
        },

        _initPackage(productGrpId, productId, propCode) {
            var productGrp = _.filter(_.get(this.priceSet, 'data'), (item) => {
                return item.productGroupId == productGrpId; //产品线
            });
            var product = _.filter(_.get(productGrp, '[0].productTypeList', []), (item) => {
                return item.productTypeId == productId;　//类型
            })[0] || {};

            // 格式化所有配置
            let  formatted = {};
            _.forEach(product.packageList, packageInfo => {
                _.forEach(packageInfo.refRegionList, region => {
                    if (!formatted[region.regionCode]) {
                        formatted[region.regionCode] = {
                            region,
                            data: {}
                        };
                    }
                    _.forEach(packageInfo.refBillTypeList, billType => {
                        if(billType.billTypeId !=1){
                            return;
                        }
                        if (!formatted[region.regionCode].data[billType.billTypeId]) {
                            formatted[region.regionCode].data[billType.billTypeId] = {
                                billType,
                                maxBandwidth: 0,
                                data: []
                            };
                        }
                        formatted[region.regionCode].data[billType.billTypeId].data.push(packageInfo);
                        let netProp = _.find(packageInfo.packageInfo, ['propCode', 'net']);
                        let max = _.get(netProp, 'propValue[0].max', 0);
                        if (formatted[region.regionCode].data[billType.billTypeId].maxBandwidth < max) {
                            formatted[region.regionCode].data[billType.billTypeId].maxBandwidth = max;
                        }
                    });
                });
            });
            // console.log(formatted," console.log(formatted)")
            this.formattedPriceData = formatted


            let regionHasConfig = _.get(formatted,this.regionKeyCheck,{})

            // if (_.isEmpty(regionHasConfig)) {
            //     return Message.error(this.$trans(`未配置，请联系客服400-028-9900`));
            // }
            try {
                let eipPriceData = this.formattedPriceData;
                let regionData = eipPriceData[this.regionKeyCheck];
                let billData = regionData.data[1];
                let configs = [];

                _.forEach(billData.data, item => {
                    let net = _.find(item.packageInfo, ['propCode', 'net']);
                    let IpNumber = _.find(item.packageInfo, ['propCode', 'IpNumber']);
                    configs.push({
                        net,
                        IpNumber
                    });
                });
                configs.sort((a, b) => {
                    let opNet = _.get(b, 'net.propValue[0].max', 0) - _.get(a, 'net.propValue[0].max', 0);
                    if (opNet != 0) {
                        return opNet;
                    }
                    return _.get(b, 'IpNumber.propValue[0].max', 0) - _.get(a, 'IpNumber.propValue[0].max', 0);
                });
                let netObj = _.get(configs[0], 'net.propValue[0]', {});
                this.maxBandwidth = netObj.max;
                this.minBandwidth = netObj.min == 0 ? 1 : netObj.min;

                this.eipLineTypeObj = _.find(list, ['LineId', this.lineType])||{};

                if (this.bandwidth > this.maxBandwidth || this.bandwidth < this.minBandwidth) {
                    this.bandwidth = this.minBandwidth
                }
                // hack：触发一下带宽值的变化，使拖拽条的样式变化
                let srcBandwidth = this.bandwidth;
                this.bandwidth = 1;
                this.$nextTick(() => {
                    console.log(srcBandwidth, 123)
                    this.bandwidth = srcBandwidth;
                    // this.exportData();
                });
            } catch(e) {
                // this.exportData();
            }

        },
        initLineSetData() {
            var list = this.LineSet;
            this.eipOrderBillLineSetFilter =  _.filter(list, (item) => {
                if (_.indexOf(this.regionKey.split('-'), 'qingdao') != -1) { //青岛机房 放开EIP静态链路的售卖
                    return item.LineType !== 'Private';
                } else {
                    return _.indexOf([this.$trans(`联通`), this.$trans(`电信`), this.$trans(`移动`), 'AuditBGP'], item.LineName) == -1 && item.LineType !== 'Private';
                }
            })

            let lineObj = _.find(this.eipOrderBillLineSetFilter,item=>item.LineName === "BGP")||{};

            if(_.isEmpty(lineObj)){
                Message.error(this.$trans(`未找到BGP链路类型`)); //未找到BGP链路类型
            }else{
                this.lineObj = lineObj;
                this.lineType = _.get(lineObj,'LineId','');
                this.provider = _.get(lineObj,'LineName','');
            }
            this.outPut();
        },
        _hasSpecialDiscount: _.debounce(function () {
            const kecQueryDisCountUrl = this.noLoginQuickCreate ? step1Const.noLoginKecQueryDisCount : step1Const.kecQueryDisCount
            //用户专属折扣
            this.$store.dispatch(kecQueryDisCountUrl, {
                Region: this.regionKeyCheck|| this.regionKey,
                ProductTypes: 303
            }).then((res) => {
                this.disCount = this.disCountObj[Object.keys(this.disCountObj)[0]];
                if (this.disCount == 1) {
                    this.hasSpecialDiscount = false;
                } else {
                    this.hasSpecialDiscount = true;
                }
                // this.$set(this, 'hasSpecialDiscount', this.disCount == 1);
            }).catch(e=>{
                Message.error(e)
            })
            //     this.$set(this, 'hasSpecialDiscount', this.disCount == 1);
            console.log('_hasSpecialDiscount timestamp', new Date() - opTimeNow);
        }, 100),
        _hasCommonDiscount: _.debounce(function () {
            const queryCommonDiscountUrl = this.noLoginQuickCreate ? step1Const.noLoginQueryCommonDiscount : step1Const.queryCommonDiscount
            //获取通用宿主机套餐
            this.$store.dispatch(queryCommonDiscountUrl, {
                params: {
                    ProductTypeId: 303, //产品类型id
                    SceneLimit: 'BUY', //使用场景标识 （标识含义：BUY 购买,RENEW 续费, UPGRADE 更配,TRIAL_TO_BUY 转正）
                    Region: this.regionKeyCheck || this.regionKey,
                    AzCodeLimit: this.azCode, //可用区标识 非必填
                    PackageLimit: this.packageCode, //套餐code 非必填
                }
            }).then((res) => {
                let disCountList = [];
                let tempMenu = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 24, 36]; //对应1，2，3，4，5，6，7，8，9，10，11月，1年，2年，3年
                let discount = 0;
                if (!_.isEmpty(res.data)) {
                    let ruleList = res.data[0].event_rule.ruleDetail;
                    let discountType = res.data[0].event_rule.discount_type;
                    if (discountType == 'SPECIAL_DISCOUNT') { //属于套餐折扣
                        this.hasPackageDiscount = true;
                    } else {
                        this.hasPackageDiscount = false;
                    }
                    _.forEach(tempMenu, (item) => {
                        _.forEach(ruleList, (subItem) => {
                            if (item == subItem.order_full_month) {
                                discount = subItem.order_reduce_discount;
                            }
                        });
                        // 产品规则: 当没有配置当前月份折扣信息时，获取上一个月份的折扣信息，所以此处利用discount变量的缓存机制
                        disCountList.push(discount);
                    });
                }
                if (disCountList.length) {
                    let _disCountList = [];
                    if (this.pageLanguage == 'zh') {
                        _disCountList = disCountList;
                    } else {
                        // 如果是英文版 则需要把折扣转换为英文的表述
                        _.forEach(disCountList, (item) => {
                            _disCountList.push(100 - item * 10);
                        });
                    }

                    this.commonDiscountList = _disCountList;
                    this.hasCommonDiscount = true;
                } else {
                    this.hasCommonDiscount = false;
                }

            }).catch((e) => {
                console.log(e)
                Message.error(e);
            });
        }, 100),

        outPut: _.debounce(function (doNotFetchVpc) {
            let me = this;
            // diskParam = this._diskParam(),
            let param = {};
            let kvm = {
                billType: '1',
                duration: this.duration,
                durationUnit: '月',
                count: this.kecCount,
                cpu: this.cpu,
                mem: this.mem,
                opstype: this.isWindows ? 1 : 2,
                ops: this.imageId,
                productType: this.kecType,
                instanceType: this.packCode ,
                sriovNetSupport: false, //20180419与燕军确认三代机写死传false
                // ssd: 50,  // 快捷购买默认不创建数据盘
                rootDisk: this.systemDiskSize, //系统盘大小
                systemDiskType: this.systemDiskType,//系统盘类型
            };
            let eip={
                bandwidth: this.bandwidth,
                billType: 1,//默认包年包月
                buyNum: this.kecCount,
                lineType: this.lineType,
                lineTypeObj: this.lineObj,
                provider: this.provider,
                time: this.duration,
            }
            let vpc ={
                subnetId:this.subnetId,
                vpcId:this.vpcId,
                securityGroupId:this.securityGroupId

            }
            param.mock = {
                regionKey: this.regionKeyCheck,
                billType:  '1',
                orderBills: [{
                    billTypeId: 1,
                    billTypeName: this.$trans(`预付费（包年包月）`)
                }],
                kecType: this.kecType,
                kecTypeList: [{
                    productTypeId: this.kecType,
                    productTypeName: this.$trans(`星河云服务器`)
                }],
                hasAz: this.hasAz,
                isEnhance: false, //20180419与燕军确认三代机写死传false
                sysDiskObj: {
                    title: this.allDiskNameMap[this.systemDiskType],
                    value: this.systemDiskType
                },
                isWindows: this.isWindows,
                diskNum: 1,
                diskSize: 0, // 默认不创建数据盘
                diskObj: {
                    maxValue: 50,
                    minValue: 50,
                    stepValue: 1,
                    title: this.$trans(`本地SSD`),
                    value: "ssd",
                },
                // snapInfo: this.snapInfo,
                imageId: this.imageId,
                kecCount: this.kecCount,
                imageType: 0,
                imageObj: this.imageObj,
                cpu: this.cpu,
                mem: this.mem,

                duration: this.duration,
                isWin2008: this.isWin2008,
                isUbuntu: this.isUbuntu,
                productType: 303,
                productName: this.$trans(`星河云服务器`),
                tryMoney: this.tryMoney,

                rootDisk: this.systemDiskSize,
                systemDiskType: this.systemDiskType,

            };

            if (this.hasAz) {
                param.mock.azCode = this.azCode;
            }



            // if (doNotFetchVpc && me.vpcId) {
            // 每次参数变动都请求QueryNetworkResource，会造成部分参数更新异常
            param.regionKey = this.regionKeyCheck;
            param.kvm = kvm;
            if (me.buyEip) {
                param.eip = eip;
            }

            this.$emit('input', param);
            this.kecinfo = _.cloneDeep(param)
            // } else {
            //     me.$store.dispatch(step1Const.QueryNetworkResource, {
            //         params: {
            //             Region: me.regionKeyCheck,
            //             AvailabilityZone: me.azCode,
            //             InstanceCount: me.kecCount
            //         }
            //     }).then(data => {
            //         param.regionKey = this.regionKeyCheck;
            //         param.kvm = kvm;
            //         if (me.buyEip) {
            //             param.eip = eip;
            //         }
            //         param.vpc = data.data;
            //         me.vpcId = _.get(data, 'data.vpcId')
            //         me.subnetId = _.get(data, 'data.subnetId');
            //         let check = _.filter(kvm, (item, key) => {
            //             return item === ''
            //         })
            //
            //         // console.log(param,"paramparamparam")
            //         this.$emit('input', param);
            //         this.kecinfo = _.cloneDeep(param)
            //     })
            // }

        }, debounceTimer),
        $dataValid(){
            let self = this;
            // if(!self.subnetId){
            //     Message.error("子网不可为空")
            // }
            // if(!self.regionKeyCheck || !self.azCode || !self.packCode || !self.imageId || !self.vpcId || !self.subnetId || !self.bandwidth || !self.kecCount || !self.duration){
            if(!self.regionKeyCheck || !self.azCode || !self.packCode || !self.imageId || !self.bandwidth || !self.kecCount || !self.duration){
                return false;
            }else {
                return true;
            }
        },
        // createVpcResult() {
        //     this.isCreateVpc = true;
        // },
        // createSubnetResult(){
        //     this.isCreateSubnet = true;
        // },
        createKec(){           
            if(this.noLoginQuickCreate){
                this.$parent.toLoginPage()
            } else {
                window.location.hash = "#/kec/create"
            }
            
        },
        _setSysDisk() {
            let systemDiskTypes = [];
    
            let propertyList = _.get(this.checkedRows, '[0].propertyList', []);
            let sys = _.get(_.filter(propertyList, ['propCode', 'systemDisks'])[0], 'propValue', []);
    
            let ebsPackages = _.find(propertyList, ['propCode', 'ebs-package']);
            let ebsCodes = [];
            let notSopportEbsCodes = []
            if (ebsPackages) {
                _.forEach(ebsPackages.propValue, item => {
                    let region = _.find(item.regionList, ['regionCode', this.regionKeyCheck]);
                    if (!region && (item.productTypeCode === 'EHDD' || item.productTypeCode === 'SSD3.0')) {
                        notSopportEbsCodes.push(item.productTypeCode)
                    }
                    if (!region) {
                        return;
                    }
                    let az = _.find(region.azList, ['azCode', this.azCode]);
                    if (!az && (item.productTypeCode === 'EHDD' || item.productTypeCode === 'SSD3.0')) {
                        notSopportEbsCodes.push(item.productTypeCode)
                    }
                    if (!az) {
                        return;
                    }
                    let billType = _.find(item.billTypeList, ['billTypeId', this.orderBill]);
    
    
                    if (!billType) {
                        return;
                    }
                    ebsCodes.push(item.productTypeCode);
                });
            }
            console.log('ebsCodes::',ebsCodes)
    
            if (sys.length > 0) {
                systemDiskTypes = [];
                _.forEach(sys, (item) => {
                    let isLocalDisk = item.value.toLowerCase().indexOf('local') != -1;
                    let availabelEbs = _.includes(ebsCodes, item.value.replace('2.0', ''));
                    let notSupportEbs = _.includes(notSopportEbsCodes, item.value.replace('2.0', ''));
                    if (isLocalDisk || availabelEbs) {
                        systemDiskTypes.push({
                            value: item.value,
                            title: this.allDiskNameMap[item.value] || item.name
                        });
                    }
                    if (notSupportEbs) {
                        systemDiskTypes.push({
                            value: item.value,
                            // title: me.$trans(item.value.replace(/\./, '_')) || item.name,
                            title: this.allDiskNameMap[item.value] || item.name,
                            isNotSupportEBS: true
                        });
                    }
                });
                if (systemDiskTypes.length === 0) {
                    systemDiskTypes = [{
                        value: '',
                        title: this.$trans(`未配置系统盘`), //未配置系统盘
                    }];
                }
            } else {
                systemDiskTypes = [{
                    value: '',
                    title: this.$trans(`未配置系统盘`), //未配置系统盘
                }];
            }
    
            //产品需求：SSD3.0排在最前面
            systemDiskTypes = _.sortBy(systemDiskTypes, (item) => {
                let ssdValue = _.last(item.value.split('.')[0].split(''));
                return Number(ssdValue) * -1; //倒序排列
            });
    
            // //产品需求：系统盘也需要检查EBS列表是否有售罄，如果有售罄项目则过滤掉
            systemDiskTypes = _.filter(systemDiskTypes, item => {
                let hasIt = _.find(this.soldoutList, soldoutItem => {
                    return soldoutItem.AvailabilityZone === this.azCode && soldoutItem.ProductCode === item.value;
                });
                // return !hasIt;
                if (hasIt && !item.isNotSupportEBS) {
                    item.isSoldOut = true
                }
                return item
            });
    
    
            this.systemDiskTypes = systemDiskTypes;
            const sysDiskObj = _.filter(systemDiskTypes, item => {
                return !item.isSoldOut && !item.isNotSupportEBS
            })[0] || {}
            this.sysDiskObj = sysDiskObj
            this.systemDiskType = sysDiskObj.value
            this.systemDiskTypesCopy = systemDiskTypes

            this._setIsShowSlider();
        },
        _setIsShowSlider() {
            if (commonConst.isAdjustSysDiskType(this.kecType)) {
                this.isShowSlider = true
                this._setSyeDiskMax()
            } else {
                this.isShowSlider = false
            }
        },
        _setSyeDiskMax() {
            // 机型维度 查询可调系统盘大小的最大值
            if (!this.isShowSlider) {
                return
            }
    
            let propertyList = _.get(this.checkedRows, '[0].propertyList', [])
            let propCode = _.get(this.systemDiskMap, _.get(this.sysDiskObj, 'value', ''), 'ssd_systemDisks')
            let systemDiskMax = _.get(_.filter(propertyList, ['propCode', propCode])[0], 'propValue[0].max', 500) //该机型可配置的大小
            if (this.systemDiskMin > systemDiskMax) {
                this.systemDiskMin = systemDiskMax
            }
         
            this.systemDiskMax = systemDiskMax
            
        },
    },
    computed: {
        ...mapState({
            tryMoney: state => state.__pbc__.step1.kecTryOrder,
            disCountObj: state => state.__pbc__.step1.disCountObj,
            kecData: state => state.__pbc__.step1.kecData,
            soldoutList: state => state.__pbc__.step1.soldoutList,
            regionInfos: state => state.__pbc__.step1.regionInfos,
            osImages: state => state.__pbc__.step1.osImages,
            imageSet: state => state.__pbc__.step1.imageSet,
            pTypeConfig: state => state.__pbc__.step1.pTypeConfig,
            snapList: state => state.__pbc__.step1.snapList,
            snapTotal: state => state.__pbc__.step1.snapTotal,
            avoidSet: state => state.__pbc__.step1.avoidSet, //权限
            pcommon: state => state.__pbc__.common,
            secNetCheck() {
                return _.filter(this.secNet, ['AvailabilityZoneName', this.azCode]);
            },
            // vpc
            allVpcSet: state => state.__pbc__.step3.allVpcSet,
            adrListSet: state => state.__pbc__.step3.adrListSet,
            AvailableIpAddress: state => state.__pbc__.step3.AvailableIpAddress,
            NotAvailableIpAddress: state => state.__pbc__.step3.NotAvailableIpAddress,
            SubnetSet: state => state.__pbc__.step3.SubnetSet,
            //eip
            priceSet: state => state.__pbc__.common.priceSet,
            LineSet: state => state.__pbc__.common.LineSet,
            bwsList: state => state.__pbc__.common.BwsSet,
            billTypeMap: state => state.__pbc__.common.billTypeMap

        }),
        discountList() {
            //从接口获取通用列表数据
            return this.commonDiscountList;
        },


    },
    watch: {
        discountList(){
            this.changeBuyData()
        },
        isKs3Region(){
            this.changeBuyData()
        },
        regionKeyCheck(){
            this.fetchAz();
            this._fetchOSImage();
            this._fetchLineSet();
            this._fetchEipData();
            this.outPut();
        },
        azCode(){
            this.fetchPack();
            // this._fetchVpcData();
            this.outPut();
        },


        packCode(val){
            let pack = _.find(this.packList,item=>item.packageCode == val)||{}
            this.checkedRows = pack.data
            if(pack){
                this.cpu = pack.cpu;
                this.mem = pack.mem;
                this.kecName = pack.productTypeName;
            }
            this._setSysDisk()
            this._hasCommonDiscount();
            this.outPut();
        },
        imageId(){
            this._onImageChange();
            this.outPut();
        },
        buyEip() {
            this.outPut();
        },
        // vpcId(val){
        //
        //     this._filterSubNet();
        //     this._filterSecurityGroup();
        //     this.outPut();
        // },

        bandwidth(val){
            this.outPut(true);
        },
        kecCount(){
            this.outPut();
        },
        maxBandwidth() {
            if (this.bandwidth > this.maxBandwidth || this.bandwidth < this.minBandwidth) {
                this.bandwidth = this.minBandwidth
            }
            // hack：触发一下带宽值的变化，使拖拽条的样式变化
            let srcBandwidth = this.bandwidth;
            this.bandwidth = 1;
            this.$nextTick(() => {
                this.bandwidth = srcBandwidth;
            });
        },
        systemDiskSize(){
            if (this.systemDiskSize < this.systemDiskObj.minValue) {
                this.systemDiskSize = this.systemDiskObj.minValue
            }
            this.outPut()
        },
        systemDiskType(){
            this.outPut()
        }
    }
}
